import { render } from "./InstructorsPage.vue?vue&type=template&id=030927c2&ts=true"
import script from "./InstructorsPage.vue?vue&type=script&lang=ts"
export * from "./InstructorsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__